import actions from './actions'

const initialState = {
  all: [],
  list: [],
  meta: [],
  active: null,
  selected: null,
  loadingAll: false,
  loadingList: false,
  loadingDetails: false,
  loadingActive: false,
  errors: {}
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state
  }
}
